<template>
  <div
    :class="{
      'scale-[1.02] border-l-2 border-primary-1 bg-light-2 dark:bg-dark-2':
        isSelected,
      'bg-light-1 dark:bg-dark-1': !isSelected,
    }"
    class="mt-5 flex items-center justify-between space-x-4 rounded-xl px-7 py-4 shadow hover:scale-[1.02] hover:dark:bg-dark-2"
  >
    <div
      class="flex w-16 flex-col text-xl font-semibold"
      :data-testId="`workTypeCode_${props.order.workTypeCode}`"
    >
      {{ workTypeCode }}
    </div>

    <div class="flex grow flex-col">
      <div class="flex flex-col">
        <div>{{ streetAndHouseNumber }}</div>
        <div>{{ zipCodeAndCity }}</div>
      </div>
    </div>

    <div
      class="flex flex-col items-center justify-center gap-1 py-3 py-5 md:flex-row md:gap-5"
    >
      <div
        v-if="props.order.status === OrderStatus.IN_PROGRESS"
        class="rounded-xl bg-light-warning px-2 py-1 text-center text-xs text-white dark:bg-transparent dark:text-yellow-500"
      >
        in Bearbeitung
      </div>
      <div class="text-center text-3xl font-semibold">{{ startTime }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Order } from '@/models/Order';
import { computed } from 'vue';
import { OrderStatus } from '@/models/types/OrderStatus';
import { formatTime} from "@/utils/dateUtils";

const props = defineProps<{
  order: Order;
  isSelected: boolean;
}>();

const startTime = computed(() => {
  return formatTime(props.order.appointment.start);
});

const streetAndHouseNumber = computed(() => {
  return (
    props.order.primaryAddress.street +
    ' ' +
    props.order.primaryAddress.houseNumber
  );
});

const zipCodeAndCity = computed(() => {
  return (
    props.order.primaryAddress.zipCode + ' ' + props.order.primaryAddress.city
  );
});

const workTypeCode = computed(() => {
  return props.order.workTypeCode ? props.order.workTypeCode : '-';
});
</script>
